"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
class HtmlWidget extends React.Component {
    render() {
        return (React.createElement("div", { dangerouslySetInnerHTML: { __html: this.props.html } }));
    }
}
exports.default = HtmlWidget;
